/* global gtag */
import { isNil } from "ramda";

import { trackMakeEvent, IN_FLOW_REGISTRATION } from "utils/makeEventUtils";
import { trackCordialLoginRegister } from "utils/cordialUtils";
import { sendRegistrationSuccessEvent } from "utils/gtmUtils";
import {
  signUpEvent,
  loginEvent,
  viewLoginEvent,
  clickLoginEvent,
  viewSignUpEvent,
  clickSignUpEvent,
  selectItemEvent,
  makeCreationSuccessEvent,
  clickPurchaseEvent,
  photoUploadEvent,
  clickPhotoUploadEvent,
  userInAppFilePickerErrorEvent,
  landingDefaultBrowserEvent,
} from "tracking/jibjab/tracking";
import {
  trackSignUpSuccess,
  trackLoginSuccess,
  trackViewLogin,
  trackLoginClick,
  trackClickSignUp,
  trackViewSignUp,
  handlerSelectItemEvent,
  trackMakeCreationSuccess,
  trackPhotoUpload,
  trackPhotoUploadSuccess,
} from "tracking/google/analytics";
import { trackCompleteRegistration } from "tracking/facebook/conversion";
import { getEcard, getInFlow, getTemplateGroup, isMake } from "utils/lastEcardUtil";

import useCategory from "./useCategory";
import usePage from "./usePage";

const useTrackAccountEvents = () => {
  const { category } = useCategory();
  const { page } = usePage();
  const trackSignUpEvents = (user, method) => {
    const currentUrl = window.location.href;
    const ecard = getEcard();
    const inFlow = getInFlow();
    const templateGroup = getTemplateGroup();

    trackCordialLoginRegister(user?.email);
    trackSignUpSuccess(method, inFlow, templateGroup);
    signUpEvent(user, method, templateGroup);
    trackCompleteRegistration(user, currentUrl);
    sendRegistrationSuccessEvent(user);
    if (!isNil(ecard) && isMake()) {
      trackMakeEvent(ecard, IN_FLOW_REGISTRATION);
    }
  };

  const trackLoginEvents = (user, method) => {
    const inFlow = getInFlow();
    const templateGroup = getTemplateGroup();

    trackCordialLoginRegister(user?.email);
    loginEvent(user, method, templateGroup);
    trackLoginSuccess(method, inFlow, templateGroup);
  };

  const trackViewSignUpEvents = (user) => {
    viewSignUpEvent(user);
    trackViewSignUp();
  };

  const trackClickSignUpEvents = (user, method) => {
    trackClickSignUp(method);
    clickSignUpEvent(user, method);
  };

  const trackViewLoginEvents = (user) => {
    viewLoginEvent(user);
    trackViewLogin();
  };

  const trackClickLoginEvents = (user, method) => {
    clickLoginEvent(user, method);
    trackLoginClick(method);
  };

  const trackSelectItemEvents = (user, item, indexPosition) => {
    handlerSelectItemEvent(item, category, null, { indexPosition, page });
    selectItemEvent(user, item, category, { indexPosition, page });
  };

  const trackMakeCreationSuccessEvents = (user, make, templateGroup) => {
    makeCreationSuccessEvent(user, make, templateGroup);
    trackMakeCreationSuccess(make, templateGroup);
  };

  const trackClickPurchaseEvents = (user, method) => {
    clickPurchaseEvent(user, method);
  };

  const trackPhotoUploadEvents = (user, method, templateGroup) => {
    photoUploadEvent(user, method, templateGroup);
    trackPhotoUploadSuccess(method, templateGroup);
  };

  const trackClickPhotoUploadEvents = (user, method, templateGroup) => {
    clickPhotoUploadEvent(user, method, templateGroup);
    trackPhotoUpload(method, templateGroup);
  };

  const trackFilePickerErrorEvents = (user, inAppBrowser) => {
    userInAppFilePickerErrorEvent(user, inAppBrowser);

    gtag("set", "user_properties", {
      user_in_app_picker_error: inAppBrowser,
    });
  };

  const trackLandingDefaultBrowserEvents = (user, inAppBrowser) => {
    landingDefaultBrowserEvent(user, inAppBrowser);
  };

  return {
    trackViewSignUpEvents,
    trackSignUpEvents,
    trackLoginEvents,
    trackViewLoginEvents,
    trackClickLoginEvents,
    trackClickSignUpEvents,
    trackSelectItemEvents,
    trackMakeCreationSuccessEvents,
    trackClickPurchaseEvents,
    trackPhotoUploadEvents,
    trackClickPhotoUploadEvents,
    trackFilePickerErrorEvents,
    trackLandingDefaultBrowserEvents,
  };
};

export default useTrackAccountEvents;
